<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1200px' }">
      <v-flex xs12 lg12 md12>
        <v-layout wrap>
          <v-card class="no-background no-shadow">
            <v-card-text class="user-title">
              Hello, {{ user.name }}
            </v-card-text>
            <v-card-text class="user-description">
              Welcome back!
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-layout v-if="isSubscriptionExpired(user.subscription_expiry_date_utc)">
        <v-flex xs12 md12 lg12>
          <v-card>
            <v-card-text class="pt-32 pb-32 pl-22 pr-22">
              <h2 class="title mb-2 ml-1 mt-3">
                Please note that your subscription has expired.<br />
                Consider topping-up your account
                <router-link :to="{ name: 'settings' }">here</router-link>
              </h2>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-if="isSubscriptionNameTrial(user.subscription_name)">
        <v-flex xs12 md12 lg12>
          <v-card>
            <v-card-text class="pt-32 pb-32 pl-22 pr-22">
              <h3 class="title mb-2 ml-1 mt-3">
                Your free trial subscription only shows 1 in 10 of all GSMG
                powered insights.<p>
                Please consider topping-up your account
                <router-link :to="{ name: 'settings' }">here</router-link> for
		full access. <p>
		The subscription cost is {{ costInsightsSubscription }} USD per 30
                days (to be pre-paid in ETH or BNB).
              </h2>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md12 lg12>
          <v-card>
            <v-card-text class="pt-32 pb-32 pl-22 pr-22">
              <h2 class="title mb-2 ml-1 mt-3">
                Recent insights
              </h2>
              <div class="user-timezone">Times in {{ timeZone }}</div>
              <v-layout row wrap>
                <v-progress-linear
                  v-if="loading"
                  indeterminate
                  :height="2"
                ></v-progress-linear>
                <div
                  v-if="!loading && !insightsMessages.length"
                  class="user-timezone ml-2 center-in-div"
                >
                  There no items yet
                </div>
                <v-flex
                  v-for="item in insightsMessages"
                  :key="item.id"
                  class="xs12 md12 lg12 pl-10 pr-10"
                >
                  <v-card class="no-shadow fill-height">
                    <div class="list-body fill-height">
                      <div v-html="convertEmoji(item.message)"></div>
                      <div class="message-time">
                        <span>
                          {{ convertEmoji(":clock1:") }}
                          {{
                            item.ts_utc | formatDate("DD MMM YYYY HH:mm")
                          }}</span
                        >
                      </div>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
              <Pagination
                :total-pages="
                  Math.round(totalMessages / pagination.rowsPerPage)
                "
                :per-page="pagination.rowsPerPage"
                :total="totalMessages"
                :current-page="pagination.page"
                @pagechanged="onPageChange"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
.center-in-div {
  margin: 0 auto !important;
}
.theme--light .user-timezone {
  color: #103a84 !important;
  margin-left: 4px;
}

.theme--light .message-time {
  white-space: normal;
  font-size: 12px;
  margin-left: auto;
  margin-right: 0;
}

.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}

>>> .theme--dark.v-toolbar {
  border-color: #424242;
  box-shadow: none;
  background: #303030;
  border-radius: 10px;
}

.theme--dark .user-timezone {
  margin-left: 4px;
}

.theme--dark .message-time {
  white-space: normal;
  font-size: 12px;
  margin-left: auto;
  margin-right: 0;
}

.theme--light .v-toolbar__title span {
  background: -webkit-linear-gradient(#468aff, #0051dd);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}

.theme--light .v-toolbar__title img {
  margin-right: 12px;
}

.theme--light .toolbar-head {
  background: #e6efff;
  border-radius: 10px;
  box-shadow: none !important;
}

.no-shadow {
  box-shadow: none !important;
}

.theme--light .list-body {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 16px;
  margin-top: 8px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #103a84;
  white-space: pre-line;
}

.theme--dark .list-body {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 16px;
  margin-top: 8px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  white-space: pre-line;
}

.theme--dark .v-toolbar__title span {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
}

.theme--dark .v-toolbar__title img {
  margin-right: 12px;
}

.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}

>>> .theme--light.v-sheet {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
}

>>> .theme--dark.v-sheet {
  background: #212121;
  border-radius: 15px;
}

>>> .theme--light .v-card__text h2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
  color: #103a84;
}

>>> .theme--dark .v-card__text h2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
}

>>> .theme--dark.v-list {
  color: #fff;
  background: transparent;
}

.no-shadow {
  box-shadow: none !important;
}

.no-background {
  background: transparent !important;
}

.theme--light .user-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 41px;
  color: #103a84;
}

.theme--light .user-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
  padding-top: 0px;
  padding-bottom: 40px;
}

.theme--dark .user-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 41px;
}

.theme--dark .user-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 0px;
  padding-bottom: 40px;
}

>>> .theme--light.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}

>>> .theme--light.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}

>>> .theme--light.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}

>>> .theme--light.v-datatable thead th.column.sortable.active,
>>> .theme--light.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--light.v-datatable thead th.column.sortable:hover {
  color: #103a84;
}

>>> .theme--light .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #7395d0;
}

>>> .theme--light .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84 !important;
  max-height: 24px;
}

>>> .theme--light
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
  padding-left: 8px;
}

>>> .theme--light .v-datatable__actions .v-input__slot {
  border: 0.8px solid #103a84;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}

>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::after,
>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::before {
  width: 0px;
}

>>> .theme--light .v-datatable__actions .v-btn {
  color: #103a84;
}

>>> .theme--light.v-btn.v-btn--disabled,
>>> .theme--light.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--light.v-btn.v-btn--disabled .v-icon {
  color: #b8d2ff !important;
}

>>> .v-datatable__actions .theme--light.v-icon {
  color: #103a84 !important;
}

>>> .v-datatable__actions .v-input__append-inner {
  margin-top: 0px !important;
}

>>> .theme--dark.v-table {
  background: #212121;
}

>>> .theme--dark.v-datatable .v-datatable__actions {
  background: #212121;
}

>>> .theme--dark.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
}

>>> .theme--dark.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}

>>> .theme--dark.v-datatable thead th.column.sortable.active,
>>> .theme--dark.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--dark.v-datatable thead th.column.sortable:hover {
  color: #ffffff;
}

>>> .theme--dark .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  max-height: 24px;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-left: 8px;
  color: #ffffff;
}

>>> .theme--dark .v-datatable__actions .v-input__slot {
  border: 0.8px solid #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}

>>> .v-datatable__actions .theme--dark.v-icon {
  color: #ffffff !important;
}

>>> .theme--dark.v-btn.v-btn--disabled,
>>> .theme--dark.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--dark.v-btn.v-btn--disabled .v-icon {
  color: rgba(235, 235, 245, 0.6) !important;
}

.theme--light .btn-share {
  background-color: #103a84 !important;
  color: #ffffff !important;
}

.theme--light .share-description {
  color: #103a84 !important;
}

>>> .theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid #e6efff;
}

>>> .theme--light.v-table tbody tr:not(:first-child) {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__actions {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__expand-col--expanded {
  border-bottom: 1px solid #e6efff;
}

.pa-32 {
  padding: 32px;
}
</style>

<script>
import { mapGetters } from "vuex";
import swal from "sweetalert2";
import axios from "axios";
import Pagination from "../../components/insights/global/Pagination";
import emojiParser from "../../plugins/emojiParser";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";

export default {
  components: { Pagination },
  metaInfo() {
    return { title: this.$t("page-dashboard") };
  },
  data: function() {
    return {
      loading: true,
      totalMessages: 0,
      insightsMessages: [],
      pagination: {
        descending: true,
        sortBy: "ts_utc",
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      themeDark: "settings/darkmode",
      subscriptions: "subscriptions/subscriptions"
    }),
    timeZone: function() {
      return moment()
        .tz(moment.tz.guess())
        .format("z");
    },
    costInsightsSubscription: function() {
      if (this.subscriptions) {
        const subscriptionsArray = Object.values(this.subscriptions);
        for (const subscription of subscriptionsArray) {
          if (subscription.name === "Insights") {
            return subscription.sub_fee_usd_per_30_days;
          }
        }
      }
      return 0;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getInsightsMessages();
      },
      deep: true
    }
  },
  created: async function() {
    if (!this.$store.getters["subscriptions/subscriptions"]) {
      this.$store.dispatch("subscriptions/fetchSubscriptions");
    }
    await this.getInsightsMessages();
  },
  methods: {
    async getInsightsMessages() {
      this.loading = true;
      let params =
        "?descending=" +
        this.pagination.descending +
        "&sortBy=" +
        this.pagination.sortBy +
        "&page=" +
        this.pagination.page +
        "&rowsPerPage=" +
        this.pagination.rowsPerPage +
        "&totalItems=" +
        this.pagination.totalItems;
      await axios
        .get("/api/v1/insights/messages" + params)
        .then(res => {
          this.insightsMessages = res.data.items;
          this.totalMessages = res.data.total;
          this.loading = false;
        })
        .catch(error => {
          this.insightsMessages = [];
          this.totalMessages = 0;
          this.loading = false;
        });
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    onPageChange(page) {
      this.pagination.page = page;
    },
    convertEmoji(text) {
      return emojiParser
        .parseToUnicode(text)
        .replace(/(https:\/\/[^\s]+)/g, "<a target='_blank' href='$1'>$1</a>");
    },
    isSubscriptionExpired(subscription_expiry_date_utc) {
      const today = new Date();
      const subscriptionDate = new Date(subscription_expiry_date_utc);
      return subscriptionDate < today;
    },
    isSubscriptionNameTrial(subscription_name) {
      return subscription_name === "Trial period Insights";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/insights/dashboard.vue